import { createRestSlice } from "./restSlice";

export type TwilioCredentials = {
  accountSid: string;
  apiKeySid: string;
  apiKeySecret: string;
  region?: string;
};

export type TelnyxCredentials = {
  apiKey: string;
};

export type TelephonyCredentials = TwilioCredentials | TelnyxCredentials;

export type OrganizationTelephony = {
  id: string;
  organizationId: string;
  name: string;
  providerType: string;
  credentials: TelephonyCredentials;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const organizationTelephonySlice = createRestSlice<OrganizationTelephony>("organizationTelephony", "/v1/organization-telephony");

export const organizationTelephonyReducer = organizationTelephonySlice.reducer;
export const organizationTelephonyActions = organizationTelephonySlice.actions;
